import { Link } from 'react-router-dom';

import { Box } from '@mui/material';

type NotFoundProps = {
    readonly useSpacing?: boolean;
};

export function NotFound({ useSpacing = false }: NotFoundProps) {
    const spacing = useSpacing ? { marginTop: '150px' } : null;
    return (
        <Box sx={spacing}>
            <h1>404 NOT FOUND</h1>
            <div>
        Go <Link to="/">home</Link>
            </div>
        </Box>
    );
}
